import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { CountrySpecEntity } from './country-spec.models'

@Injectable({
  providedIn: 'root',
})
export class CountrySpecApiService extends GbApiService {
  getCountrySpec(): Observable<CountrySpecEntity[]> {
    const url = 'country-specs/'
    return this.get<CountrySpecEntity[]>(url, {
      withCredentials: false,
    })
  }
}
